/**
 * top-level フィールド単位の diff (§4.1)。
 * serializeDoc 済みの新旧スナップショットを比較し、updateDoc に載せる最小集合を出す。
 *
 * - キーは新旧の**和集合**を走査する — serializer が undefined キーを除去するため、
 *   クリアされた top-level optional は新側に存在しない。新側のみ走査だと消失
 *   を検知できず deleteField が永久に発行されない (§4.1)。
 * - deleted に載せてよいのは top-level のみ (deleteField のネスト埋め込みは SDK
 *   エラー §2.5)。ネストのクリアは親 map 置換 (changed) で表現される。
 */
export interface TopLevelDiff {
  changed: Record<string, unknown>;
  deleted: string[];
}

export function diffTopLevel(
  prev: Record<string, unknown>,
  next: Record<string, unknown>,
): TopLevelDiff {
  const changed: Record<string, unknown> = {};
  const deleted: string[] = [];
  const keys = new Set([...Object.keys(prev), ...Object.keys(next)]);
  for (const key of keys) {
    const inPrev = key in prev;
    const inNext = key in next;
    if (inPrev && !inNext) {
      deleted.push(key);
      continue;
    }
    if (!inPrev && inNext) {
      changed[key] = next[key];
      continue;
    }
    if (JSON.stringify(prev[key]) !== JSON.stringify(next[key])) {
      changed[key] = next[key];
    }
  }
  return { changed, deleted };
}
